export default __webpack_public_path__ + "i18n/translations/translation-ar.1569ff6b.json";